import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Radio } from '../../../../../design/inputs/radio/S_Radio';
import { S_ClampLines } from '../../../../../design/misc/S_ClampLines';
import { doNothing } from '../../../../helpers/function.helpers';
import { IAnswerProps } from '../../question.model';

export const AnswerWithRadioButton = observer(({ disabled, name, answer, onAnswered }: IAnswerProps): ReactElement => {
  return (
    <S_Radio
      slotProps={{
        input: { tabIndex: 1 },
      }}
      name={name}
      id={answer.id}
      value={answer.id}
      checked={answer.selected ?? false}
      onClick={
        disabled
          ? doNothing
          : (): void => {
              onAnswered(answer.selected ? '' : answer.id);
            }
      }
      disabled={disabled}
      label={
        <S_ClampLines
          text={answer.text}
          lines={3}
        />
      }
    />
  );
});
